<div class="reflection-content">
  <div *ngIf="!questionSet">
    <p>No Question Data</p>
  </div>
  <kp-accordion *ngIf="questionSet">
    <div *ngFor="let question of questions">
      <kp-accordion-group
        *ngIf="
          question.answer &&
          question.answer.values &&
          question.inputType !== QuestionType.image_icon_selection &&
          question.inputType !== QuestionType.image_word_list
        "
        [id]="question.id">
        <h3 class="title" acc-open>{{ question.display?.title }}</h3>
        <span acc-collapsible>{{ question | answerValue }}</span>
      </kp-accordion-group>
      <kp-accordion-group
        *ngIf="question.answer && question.answer.values && question.inputType === QuestionType.image_icon_selection"
        [id]="question.id">
        <h3 class="title" acc-open>{{ question.display?.title }}</h3>
        <kp-smiley-row acc-collapsible [selectedIndex]="question | imageAnswerIndex"></kp-smiley-row>
      </kp-accordion-group>
      <kp-accordion-group
        *ngIf="question.answer && question.answer.values && question.inputType === QuestionType.image_word_list"
        [id]="question.id">
        <h3 class="title" acc-open>{{ question.display?.title }}</h3>
        <kp-image-icon-list acc-collapsible [imageAndIcons]="question | imageWordListAnswer"></kp-image-icon-list>
      </kp-accordion-group>
    </div>
  </kp-accordion>
</div>
